










































// @ is an alias to /src
import { Vue, Component } from 'vue-property-decorator';
import registerComp from '@/components/RegisterComp.vue';
import PermUtil from '@/model/PermUtil';

@Component({
  components: {
    registerComp,
  },
})
export default class Register extends Vue {
  regis = true;

  mounted() {
    if (this.currentUser.organizations.length) {
      this.$store.dispatch('bindFevorateOrgs', this.currentUser.organizations);
    }
  }

  get Orgs() {
    return this.$store.state.fevorateOrgs;
  }
  // eslint-disable-next-line
  get showRegister() {
    return PermUtil.canCreateOrganization();
  }

  orgComp(org: any) {
    this.$store.commit('setOrg', org);
    this.$router.push(`/organization/${org.id}`);
  }

  get currentUser() {
    return this.$store.state.freshCurrentUser;
  }
}
